import { Box, Button, FlexBox, Icon } from '@vp/swan'
import { useTranslation } from 'react-i18next'
import { usePageFlow } from '../../context/page-flow-context'
import { useTracking } from '../../hooks/use-tracking'
import styles, { stylesheet } from './styles.scss'
import { useStyles } from '@vp/ubik-context'

export const PageFooter = () => {
  const { t } = useTranslation()
  useStyles(stylesheet)
  const { goBack, showBack, nextConfig, nextLoading, fireOnNext } = usePageFlow()
  const { trackNavNext } = useTracking()

  const nextLabel = nextConfig.label ?? t('contact_us.page.actions.next')

  const handleNext = () => {
    trackNavNext()
    fireOnNext()
  }

  return (
    <Box px={7} className={styles.pageFooter}>
      <FlexBox justifyContent="space-between" alignItems="center">
        {showBack ? (
          <Button data-testid="flow-nav-back-button" skin="tertiary" iconPosition="left" onClick={goBack} disabled={nextLoading}>
            <Icon iconType="arrowLeft" />
            {t('contact_us.page.actions.back')}
          </Button>
        ) : (
          <Box />
        )}
        <Button
          data-testid="flow-nav-next-button"
          data-nav-action={nextConfig.label ? 'submit' : 'next'}
          loading={nextLoading}
          skin="primary"
          onClick={handleNext}
          disabled={nextConfig.disabled !== false || nextLoading}
        >
          {nextLabel}
        </Button>
      </FlexBox>
    </Box>
  )
}
